import { render, staticRenderFns } from "./RunnitTemplatesOnboardingBanner.vue?vue&type=template&id=81d5ac58&scoped=true"
import script from "./RunnitTemplatesOnboardingBanner.vue?vue&type=script&lang=ts"
export * from "./RunnitTemplatesOnboardingBanner.vue?vue&type=script&lang=ts"
import style0 from "./RunnitTemplatesOnboardingBanner.vue?vue&type=style&index=0&id=81d5ac58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d5ac58",
  null
  
)

export default component.exports